const styles = () => ({
  tagCloseIcon: {
    padding: '6px',
    marginTop: '-3px',
  },
});

export default styles;
